import React from 'react';
import './App.css';
import ChatBox from "./components/Chatbox"

function App() {
  return (
    <div className="page">
      <div className="Main-card">
        <header className="header">
          <div className="logo">EG</div>
          <nav className="nav">
            <a href="https://www.linkedin.com/in/ethan-geffroy-562552320/" target="_blank" rel="noreferrer" className='link'>LinkedIn</a>
            <a href="mailto:ethangeffroy15@gmail.com" className='link'>Mail</a>
          </nav>
          <a href="CV_Ethan_GEFFROY.pdf" download="CV_Ethan_GEFFROY.pdf" className="CV-button">
            Télécharger mon CV
          </a>
        </header>
        <section className="hero">
          <div className="hero-text">
            <p className="hero-label">Portfolio Web</p>
            <h1>
              Ethan GEFFROY<br />
              Étudiant à Epitech Paris<br />
            </h1>
            <p className="hero-desc">
              Epitech (1ʳᵉ année, promo 2030) / Développeur Logiciel Junior<br />
              Objectif :  Stage de 4 à 6 mois à partir de Juillet 2026<br /><br />
              Passionné par la programmation et l’intelligence artificielle, je développe mes compétences en algorithmie, en C et en environnement Linux. Curieux, sérieux et motivé, je cherche un stage en informatique.
            </p>
          </div>
          <div className="chat-card">
            <ChatBox />
          </div>
        </section>
        <div className="Scroll-container">
          <img className="Scroll-image" src="scroll.png" alt="Scroll down"/>
        </div>
      </div>
      <div className="Second-card">
        <div className="Project-card">
          <h2 className="Project-card-title">Portfolio Chat IA (Perso)</h2>
          <div className="Langage-cards-wrapper">
            <div className="Langage-card">TypeScript / CSS</div>
            <div className="Langage-card">Python</div>
          </div>
          <p className="Project-card-desc">Portfolio avec API Gemini connecté</p>
          <div className="Competence-card">
            <p>Gemini API</p>
          </div>
        </div>
        <div className="Project-card">
          <h2 className="Project-card-title">Organized</h2>
          <p className="Project-card-desc">Algorithme de tri (merge sort) et manipulation des listes chaînées</p>
          <div className="Langage-cards-wrapper">
            <div className="Langage-card">C</div>
          </div>
          <div className="Competence-card">
            <p>Algo tri : Merge</p>
          </div>
        </div>
        <div className="Project-card">
          <h2 className="Project-card-title">My_radar</h2>
          <p className="Project-card-desc">Projet graphique, gestion de beaucoup de collisions avec un quadtree</p>
          <div className="Langage-cards-wrapper">
            <div className="Langage-card">C / CSFML</div>
          </div>
          <div className="Competence-card">
            <p>Collision : quadtree</p>
          </div>
        </div>
        <div className="Project-card">
          <h2 className="Project-card-title">Drone FPV (Perso)</h2>
          <p className="Project-card-desc">Fabrication de mon propre drone fpv, commande et assemblage des pièces, soudures, programmation du contrôleur de vol, configuration firmware, etc</p>
          <div className="Competence-card">
            <p>Autonomie</p>
          </div>
        </div>
        <section className="stats">
          <div className="stat-card">
            <p className="stat-title">Compétences</p>
            <p className="stat-value">C (base solide)<br />Shell (base solide )<br />Python (en apprentissage)<br />TypeScript (en apprentissage)</p>
          </div>
          <div className="stat-card">
            <p className="stat-title">Outils</p>
            <p className="stat-value">Vs code<br />Git / GitHub<br />Linux<br />Makefile</p>
          </div>
          <div className="stat-card">
            <p className="stat-title">Méthodologie</p>
            <p className="stat-value">Travail en mode projet<br />Apprentissage en autonomie<br />Peer learning<br />Respect des deadlines</p>
          </div>
          <div className="stat-card">
            <p className="stat-title">Soft Skills</p>
            <p className="stat-value">Adaptation rapide<br />Apprentissage rapide<br />Autonomie<br /></p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default App;
